import { Component, Input } from '@angular/core';
import { FreudDialogService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';

import { PromptuaryComplianceModal } from '../promptuary-compliance-modal/promptuary-compliance-modal';

@Component({
	selector: 'promptuary-compliance-section',
	templateUrl: './promptuary-compliance-section.html',
	styleUrls: ['./promptuary-compliance-section.scss'],
})
export class PromptuaryComplianceSection {
	@Input() type: 'default' | 'crm';
	@Input() from;
	@Input() mainType;
	constructor(
		public translateService: TranslateService,
		public dialogService: FreudDialogService
	) {}

	openModal() {
		this.dialogService.open(PromptuaryComplianceModal, {
			header: this.translateService.instant(
				'PROMPTUARY.COMPLIANCE.MODAL.TITLE'
			),
			width: '374px',
			data: {
				type: this.type,
				from: this.from,
				mainType: this.mainType,
			},
		});
	}
}
